// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_pnpm_firebase_11_9_1_node_modules_firebase_compat_analytics_dist_esm_index_esm_js":"40a793c9e48e2470","shared_utilities_integration_ts":"09bb9c2fb9d8ce03","node_modules_pnpm_xlsx_0_18_5_node_modules_xlsx_xlsx_mjs":"673f94b31d82adee"}[chunkId] + ".js";
};